import { ProductPrice } from "../ProductPrice/ProductPrice";
import { SimpleImage } from "../SWImage/SWImage";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFormatCurrency } from "@ten24/slatwall-storefront-react-private/global";
import { useState } from "react";
import { getProductRoute } from "@ten24/slatwall-storefront-react-private/global";

const CartLineItem = ({
  childBundleItems,
  orderItem,
  isDisabled = false,
  isFetching = false,
  setRemoveitem = () => {},
  onUpdateQty,
  onRemoveItem,
}) => {
  const [formatCurrency] = useFormatCurrency({});
  const { t } = useTranslation();
  const productRouting = useSelector(getProductRoute);
  const isBackordered = false;
  const [itemCount, setItemCount] = useState(orderItem.quantity);

  return (
    <div className="row py-3 cart-item-box">
      <div className="image">
        {orderItem.sku.images && orderItem.sku.images?.length > 0 && (
          <SimpleImage
            className="img-fluid  m-auto image_container productImage"
            src={orderItem.sku.images?.at(0)}
            alt={orderItem.sku.product.productName}
            type="product"
          />
        )}
      </div>
      <div className="detail">
        <div className="title d-flex justify-content-between">
          <h4>
            <Link
              to={{
                pathname: `/${productRouting}/${orderItem.sku.product.urlTitle}`,
                state: { ...orderItem.sku.product },
              }}
              className="text-decoration-none text-dark"
            >
              {orderItem.sku.product.productName}
            </Link>
          </h4>
          <div className="item-delete-btn">
            <span
              className="bi bi-trash clickable"
              disabled={isFetching}
              onClick={(event) => onRemoveItem(event)}
            ></span>
          </div>
        </div>
        <div className="d-flex justify-content-between bottom-detail-box">
          <div className="font-size-sm item-sku">
            <span className="mr-2">SKU : {orderItem.sku.skuCode}</span>
          </div>
          <div className="justify-content-between item-price">
            <ProductPrice
              type="cart"
              salePrice={orderItem.extendedUnitPriceAfterDiscount}
              listPrice={orderItem.sku.listPrice}
              salePriceSuffixKey="frontend.core.each"
              accentSalePrice={false}
            />
          </div>
          {isBackordered && (
            <>
              <i className="fal fa-exclamation-circle"></i>
              <p className="text-sm mb-0">{t("frontend.order.backorder")}</p>
            </>
          )}
          {!isDisabled ? (
            <>
              <div className="number-range d-flex">
                <input
                  type="number"
                  className=""
                  value={itemCount}
                  disabled={isFetching && orderItem.sku.skuID}
                  onChange={(e) => {
                    setItemCount(e.target.value);
                  }}
                />
                <button
                  className="btn text-muted btn-link p-1 text-end"
                  onClick={() => onUpdateQty(itemCount)}
                >
                  {t("frontend.account.cart.item.updateQuantity")}
                </button>
              </div>
              <h5 className="total-price">{formatCurrency(orderItem.extendedPriceAfterDiscount)}</h5>
            </>
          ) : (
            <>
              <div className="col-sm-3">
                <small>{t("frontend.cart.quantity")}</small>{" "}
                {orderItem.quantity}
              </div>
              <div className="col-sm-4">
                <h6>
                  <span className="text-muted">
                    <strong>
                      {formatCurrency(orderItem.extendedPriceAfterDiscount)}
                    </strong>
                  </span>
                </h6>
              </div>
            </>
          )}
        </div>
      </div >
      <div className="row">
        {childBundleItems &&
          childBundleItems.length > 0 &&
          childBundleItems.map((childBundleItem, key) => {
            return (
              <div className="col-3 d-flex" key={childBundleItem.orderItemID}>
                {key !== 0 ? (
                  <i className="bi bi-plus-circle col-2 align-self-center"></i>
                ) : (
                  <div className="col-2"></div>
                )}
                <Link
                  className="col-10"
                  to={`/${productRouting}/${childBundleItem.sku.product.urlTitle}`}
                >
                  <SimpleImage
                    className="img-fluid  m-auto image_container productImage border border-light"
                    src={childBundleItem.sku.images?.at(0)}
                    alt={childBundleItem?.sku?.product?.productName}
                    type="product"
                  />
                  <span className="text-dark">
                    {" "}
                    {`${formatCurrency(childBundleItem.price)} x ${
                      childBundleItem.quantity
                    }`}
                  </span>
                  <p>{childBundleItem?.sku?.product?.productName}</p>
                </Link>
              </div>
            );
          })}
      </div>
    </div>
  );
};
export { CartLineItem };

